import React from 'react'
import CartItems from '../components/CartItems/CartItems'

export const Cart = () => {
  return (
    <div>
      <CartItems/>
    </div>
  )
}
export default Cart
  